/**
 * Image URL utilities for Core Frontend
 */

import { getS3ProductsUrl, getS3LogosUrl } from '@/providers/PlatformBootstrapProvider';

/**
 * Get full product image URL from relative path
 *
 * Handles both relative paths (from Catalog API) and absolute URLs (legacy)
 *
 * @param relativePath - Relative path like "products/{modelGuid}/0.webp" or absolute URL
 * @returns Full URL to product image
 *
 * @example
 * getProductImageUrl("products/abc-123/0.webp")
 * // Returns: "https://s3.teletienda.ar/teletienda-products/products/abc-123/0.webp"
 *
 * getProductImageUrl("https://cdn.example.com/image.jpg")
 * // Returns: "https://cdn.example.com/image.jpg" (unchanged)
 */
export function getProductImageUrl(relativePath: string | null | undefined): string | undefined {
  if (!relativePath) {
    return undefined;
  }

  // If already an absolute URL, return as-is
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }

  // Build full URL from relative path
  return `${getS3ProductsUrl()}/${relativePath}`;
}

/**
 * Get deterministic merchant logo URL based on merchantGuid
 *
 * Logo URL pattern: https://s3.teletienda.ar/merchant-logos/{merchantGuid}.webp
 *
 * @param merchantGuid - Merchant UUID
 * @returns Full URL to merchant logo
 */
export function getMerchantLogoUrl(merchantGuid: string): string {
  return `${getS3LogosUrl()}/${merchantGuid}/logo.webp`;
}
